exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2djtJ{text-align:center;font-family:Roboto}._2198B{color:#fff;background-color:#e4002b;border-color:#e4002b;cursor:pointer;font-family:Roboto\\, Medium}._2hWTb,._36yAl{padding:20px 50px}._14FwJ{display:block;padding:20px 100px}.qZsK9{font-family:Roboto\\, Medium}._1BidJ,.qZsK9{font-size:14px}input:focus{border-color:#e4002b!important}._1TY6G{font-family:Roboto\\, Medium}.NbSzY{color:#e4002b}.xMyvK{color:#333;background-color:#fff;border-color:#ccc;cursor:pointer;width:140px}", ""]);

// exports
exports.locals = {
	"modalContent": "_2djtJ",
	"boton_rojo": "_2198B",
	"modalHeader": "_36yAl",
	"modalBody": "_2hWTb",
	"modalFooter": "_14FwJ",
	"boldText": "qZsK9",
	"regularText": "_1BidJ",
	"robotoMedium": "_1TY6G",
	"text_danger": "NbSzY",
	"boton_blanco": "xMyvK"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/ModalIngresoDireccionActual/ModalIngresoDireccionActual.css
// module id = 1230
// module chunks = 0 1 2